import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "../pages/home/home";
import Contact from "../pages/contact/contact";
import Service from "../pages/service/service";
import ServicesPage from "../pages/services/services";
import RsaServices from "../pages/rsa-services/rsa-services";
import About from "../pages/about/about";
import Terms from "../pages/terms/terms";
import Privacy from "../pages/privacy/privacy";
import Blog from "../pages/blog/blog";
import BlogDetail from "../pages/blog/blog-detail";
import ComingSoon from "../pages/coming-soon/coming-soon";
import TrackService from "../pages/track-service/track-service";
import NotFound from "../pages/not-found/not-found";
import Login from "../pages/login/login";
import Register from "../pages/register/register";
import ForgotPassword from "../pages/forgot-password/forgot-password";
import MechanicForgotPassword from "../pages/mechanic-forgot-password/mechanic-forgot-password";
import Dashboard from "../pages/dashboard/dashboard";
import MyBookings from "../pages/my-bookings/my-bookings";
import BookService from "../pages/book-service/book-service";
import Profile from "../pages/profile/profile";
import RsaJoin from "../pages/rsa-join/rsa-join";
import Payment from "../pages/payment/payment";
import MechanicDashboard from "../pages/mechanic-dashboard/mechanic-dashboard";
import MechanicJobs from "../pages/mechanic-jobs/mechanic-jobs";
import MechanicProfile from "../pages/mechanic-profile/mechanic-profile";
import MechanicEarnings from "../pages/mechanic-earnings/mechanic-earnings";
import MechanicNotifications from "../pages/mechanic-notifications/mechanic-notifications";
import ProtectedRoute from "./ProtectedRoute";
import MechanicProtectedRoute from "./MechanicProtectedRoute";
import { COMING_SOON_PATHS } from "../constants/routes";

const AppRoutes = () => (
  <Routes>
    {/* Public routes */}
    <Route path="/" element={<Home />} />
    <Route path="/services" element={<ServicesPage />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/services/:serviceName" element={<Service />} />
    <Route path="/rsa-services" element={<RsaServices />} />
    <Route path="/about" element={<About />} />
    <Route path="/terms" element={<Terms />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/blog" element={<Blog />} />
    <Route path="/blog/:slug" element={<BlogDetail />} />
    <Route path="/track-service" element={<TrackService />} />
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ForgotPassword />} />

    {/* Customer private routes */}
    <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
    <Route path="/my-bookings" element={<ProtectedRoute><MyBookings /></ProtectedRoute>} />
    <Route path="/book-service" element={<ProtectedRoute><BookService /></ProtectedRoute>} />
    <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
    <Route path="/rsa-join" element={<ProtectedRoute><RsaJoin /></ProtectedRoute>} />
    <Route path="/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />

    {/* Mechanic portal private routes */}
    <Route path="/mechanic/login" element={<Login />} />
    <Route path="/mechanic/forgot-password" element={<MechanicForgotPassword />} />
    <Route path="/mechanic/reset-password" element={<MechanicForgotPassword />} />
    <Route path="/mechanic/dashboard" element={<MechanicProtectedRoute><MechanicDashboard /></MechanicProtectedRoute>} />
    <Route path="/mechanic/jobs" element={<MechanicProtectedRoute><MechanicJobs /></MechanicProtectedRoute>} />
    <Route path="/mechanic/profile" element={<MechanicProtectedRoute><MechanicProfile /></MechanicProtectedRoute>} />
    <Route path="/mechanic/earnings" element={<MechanicProtectedRoute><MechanicEarnings /></MechanicProtectedRoute>} />
    <Route path="/mechanic/notifications" element={<MechanicProtectedRoute><MechanicNotifications /></MechanicProtectedRoute>} />

    {/* Coming soon */}
    {COMING_SOON_PATHS.map((path) => (
      <Route key={path} path={path} element={<ComingSoon />} />
    ))}

    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default AppRoutes;
